<template>
  <div class="mb-5">
    <template v-if="userHasAccess">
      <template v-if="loaded && !loadError">
        <div class="top-content-bar">
          <div class="wrapper">
            <div class="flex flex-align-items-center py-1 flex-wrap flex-justify-content-between">
              <f-button
                class="text-uppercase mr-5 "
                theme="go-back"
                withArrow
                withArrowBackwards
                @click.prevent="$router.push('/klienci')">
                {{ $t('customer.backToCustomerList') }}
              </f-button>

              <div
                v-if="loaded"
                class="flex flex-align-items-center mb-2-sm flex-wrap">
                <div class="small mr-3 my-1 full-width-sl">
                  {{ $t('customersList.lastLogin') }}: {{ formatDate(data.last_login_at) }}
                </div>
                <div class="mr-3 small my-1 full-width-sl">
                  {{ $t('customersList.lastInteraction') }}: {{ formatDate(data.last_activity_at) }}
                </div>
                <div class="small my-1 full-width-sl">
                {{ $t('customer.customerNumber') }}: {{ data.id }}
                </div>
              </div>
            </div>
            <div class="flex full-width">
              <div
                v-if="loaded"
                class="flex flex-justify-content-between flex-align-items-center flex-wrap full-width">
                <div class="flex flex-align-items-center mb-2">
                  <img
                    class="mr-2 block my-auto customer-img hidden-mobile-small"
                    src="@/assets/images/default-avatar.png"
                    :alt="$t('client.clientAvatar')">
                  <div class="my-auto">
                    <h1 class="heading-bigger full-width">{{ data.name }} {{ data.surname }}</h1>

                    <a
                      v-if="data.city"
                      href="#"
                      class="lnk lnk-contact mr-3 mt-1 mt-2-sm full-width-ms mr-0-sm">
                      <f-icon name="map-pin" />
                      {{ data.city }}
                    </a>
                    <a
                      v-if="data.phone"
                      :href="'tel:' + removeSpacesFromString(data.phone)"
                      class="lnk lnk-contact mr-3 mt-1 mt-2-sm full-width-ms mr-0-sm">
                      <f-icon name="phone" />
                      {{ data.phone }}
                    </a>
                    <a
                      v-if="data.email"
                      :href="'mailto:' + data.email"
                      class="lnk lnk-contact mt-1 mt-2-sm full-width-ms">
                      <f-icon name="mail" />
                      {{ data.email }}
                    </a>
                  </div>
                </div>
                <div class="flex flex-align-items-center mb-2">
                  <f-button
                    v-if="data.customer_status === 'DRAFT'"
                    class="mr-2"
                    theme="primary"
                    @click.prevent="sendInvitation">
                    {{ $t('customer.sendInvitation') }}
                  </f-button>

                  <f-badge
                    v-if="customerStatus"
                    :theme="customerStatus.theme">
                    {{ customerStatus.text }}
                  </f-badge>
                </div>
              </div>

            </div>
          </div>
        </div>

        <f-tabs
          ref="customer-main-tabs"
          :items="tabItems"
          :defaultActiveItem="defaultActiveTab">
          <div slot="tab-0">
            <inquiries-list
              :withFilters="false"
              :hasPagination="true"
              :listSource="'adviser/inquiries/items'"
              :requestWhere="data.customer_id ? { customer_id: data.customer_id } : { customer_email: data.email }"
              :noMessages="true"
              :incustomerPreview="true"
              :itemRoute="'/klienci/' + data.id + '/lista-ofert/'" />
          </div>
          <div slot="tab-1">
            <template v-if="data.customer_id">
              <customer-messages-wrapper
                :customerID="data.id"
                :requestWhere="{ customer_id: data.customer_id }" />
            </template>
            <template v-else>
              <f-alert
                class="my-3"
                theme="warning"
                visible>
                {{ $t('customer.customerAccountNotActive') }}
              </f-alert>
            </template>
          </div>
          <div slot="tab-2">
            <customer-settings
              :customer="data" />
          </div>
          <div slot="tab-3">
            <notes-list
              :customerID="data.id" />
          </div>
        </f-tabs>
      </template>
      <template v-else>
        <div
          v-if="!loaded && !loadError"
          class="loading-spinner-wrapper">
          <div class="loading-spinner pb-3 pt-3">
            <span class="loading-spinner-content">
              {{ $t('ui.loadingDataInProgress') }}&hellip;
            </span>
          </div>
        </div>
        <div class="wrapper mt-3">
          <f-alert
            v-if="loadError"
            visible
            theme="warning">
            <span>
              {{ $t('ui.dataLoadError.dataErrorMess') }} <a href="javascript:window.location.reload();" class="lnk lnk-alert">{{ $t('ui.dataLoadError.resetPageButton') }}</a> {{ $t('ui.dataLoadError.forTryAgain') }}
            </span>
          </f-alert>
        </div>
      </template>
    </template>
    <div
      v-else
      class="wrapper pt-3 pb-1">
      <f-alert
        visible
        class="my-2"
        theme="inactive">
        <span>
        {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
        </span>
      </f-alert>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import InquiryStatuses from '@/data/inquiry-statuses.js';
import CustomerSettings from './CustomerSettings.vue';
import CustomerMessagesWrapper from './CustomerMessagesWrapper.vue';
import CustomerStatuses from '@/data/customer-statuses.js';
import InquiriesList from '@/views/lists/InquiriesList.vue';
import NotesList from '@/views/lists/NotesList.vue';

export default {
  name: 'customer',
  components: {
    'customer-settings': CustomerSettings,
    'customer-messages-wrapper': CustomerMessagesWrapper,
    'inquiries-list': InquiriesList,
    'notes-list': NotesList
  },
  computed: {
    userHasAccess () {
      return this.$store.getters.getUserHasFeature('customers');
    },
    isEdit () {
      return !!this.$route.params.id;
    },
    inquiryStatus() {
      let status = InquiryStatuses.find((element) => element.value === this.data.status);

      if (status) {
        return status;
      }

      return {
        value: 'dark',
        text: this.$t('customer.incorrectStatus'),
      };
    },
    tabItems () {
      return [
        {
          title: this.$t('customer.customerCreditOffers'),
          name: 'customer-inquiries',
          titleMobile: 'Oferty'
        },
        {
          title: this.$t('ui.messages'),
          name: 'customer-messages'
        },
        {
          title: this.$t('ui.settings'),
          name: 'settings'
        },
        {
          title: this.$t('ui.notes'),
          name: 'notes'
        },
      ];
    },
    customerStatuses () {
      return CustomerStatuses;
    },
    customerStatus () {
      let status = this.customerStatuses.find(element => element.value === this.data.customer_status);

      if (status) {
        return {
          theme: (this.data.customer_status).toLowerCase().replaceAll('_', '-'),
          text: status.text
        }
      }

      return null
    },
    defaultActiveTab () {
      if (!this.$route.meta || !this.$route.meta.activeTab) {
        return 0;
      }

      return this.tabItems.indexOf(this.tabItems.find(item => item.name === this.$route.meta.activeTab));
    }
  },
  watch: {
    userHasAccess (newValue) {
      if (newValue && !this.viewInitiated) {
        this.loadItemData();
      }
    }
  },
  data() {
    return {
      data: {
        id: 0,
        customer_id: 0,
        name: '',
        surname: '',
        email: '',
        phone: '',
        city: '',
        post_code: '',
        customer_status: '',
        customer_status_at: '',
        last_activity_at: '',
        last_login_at: '',
        inquiries_count: 0,
        new_inquiries_count: 0,
        message_topics_count: 0,
        new_message_topics_count: 0,
        accepted_terms_and_policy_privacy: false,
        contact_adviser_agreement: false,
        contact_finhub_agreement: false
      },
      loaded: false,
      loadError: false,
      actionInProgress: false,
      viewInitiated: false
    };
  },
  mounted () {
    if (this.userHasAccess) {
      this.loadItemData();
    }
  },
  methods: {
    loadItemData () {
      Vue.set(this, 'viewInitiated', true);

      FormUtils.loadItemData(this, {
        method: 'get',
        endpointBase: '/api/adviser/customers/item/',
        instanceFields: [
          'id',
          'customer_id',
          'name',
          'surname',
          'email',
          'phone',
          'city',
          'post_code',
          'customer_status',
          'customer_status_at',
          'last_activity_at',
          'last_login_at',
          'inquiries_count',
          'new_inquiries_count',
          'message_topics_count',
          'new_message_topics_count',
          'accepted_terms_and_policy_privacy',
          'contact_adviser_agreement',
          'contact_finhub_agreement',
        ],
        booleanFields: ['accepted_terms_and_policy_privacy', 'contact_adviser_agreement', 'contact_finhub_agreement'],
        loadedKey: 'loaded'
      });
    },
    formatDate (date) {
      if (!date) {
        return this.$t('ui.none').toLowerCase();
      }

      let dateObject = new Date(date);

      return [
        dateObject.getDate(),
        dateObject.getMonth() + 1,
        dateObject.getFullYear().toString().substr(-2)
      ].map(n => n < 10 ? '0' + n : n).join('.') + ' o godz. ' + [
        dateObject.getHours(),
        dateObject.getMinutes()
      ].map(n => n < 10 ? '0' + n : n).join('.');
    },
    sendInvitation () {
      this.actionInProgress = true;

      FormUtils.submitWithConfirm(this, {
        endpoint: '/api/adviser/customers/send-invitation/' + this.data.id,
        successTitle: this.$t('customersList.inviteCustomer'),
        successText: this.$t('customersList.invitationSentToCustomer'),
        confirmTitle: this.$t('customersList.areYouSureSendAnInvitation'),
        confirmText: this.$t('ui.thisOperationCannotUndone'),
        confirmButtonText: this.$t('ui.yesInvite'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('customersList.sendInvitationError'),
        successAction: () => {
          this.actionInProgress = false;
          this.loadItemData();
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      });
    },
    removeSpacesFromString (str) {
      if (!str) {
        return '';
      }

      return str.replace(/\s/g, '');
    }
  }
};
</script>

<style scoped lang="scss">
.customer-img {
  height: 67px;
  width: 68px;
}
</style>
